import { useQuery } from "react-query";
import { getBusinessOperation } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveBusinessOperation = () => {
  return useQuery("BusinessOperation", getBusinessOperation, {
    refetchOnWindowFocus: false,
  });
};
